import { PhasrRecommendationsView } from '../view/PhasrRecommendationsView';
import { templatePhasrRecommendations } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../framework/BaseWebComponentController';
import { PhasrRecommendationsWebComponent } from '..';

export class PhasrRecommendationsController extends BaseWebComponentController {
  public component: PhasrRecommendationsWebComponent;
  public view: PhasrRecommendationsView;
  public viewConstructor: typeof PhasrRecommendationsView;

  constructor(component: PhasrRecommendationsWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: PhasrRecommendationsView,
      viewTemplate: templatePhasrRecommendations,
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [];
  }
}
